import { jsx as c } from "react/jsx-runtime";
import { createContext as l, useContext as s, useCallback as P } from "react";
function L(t, e) {
  return t.startsWith("/") ? t : [e, t].filter((r) => !!r).join("/").replace(/^\/?/, "/");
}
function w(t, e) {
  return (r) => {
    let n = "";
    if (/^(https?:|mailto:|tel:)/.test(r))
      return r;
    n = L(r, t);
    const [i, d] = n.split("?"), o = new URLSearchParams(d);
    for (const [m, v] of e.entries())
      o.set(m, v);
    const u = o.toString() ? `?${o.toString()}` : "";
    return `${i}${u}`;
  };
}
const f = l(void 0), h = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "utm_id",
  "utm_campaign_id",
  "utm_gads",
  "fbclid",
  "gclid",
  "ttclid",
  "msclkid",
  "_kx",
  "dema_id"
], W = ({
  urlSearchParams: t,
  whitelistedQueryParamKeys: e,
  children: r
}) => {
  const i = (e ?? h).reduce(
    (o, u) => {
      if (t.has(u)) {
        const m = t.get(u);
        m !== null && (o[u] = m);
      }
      return o;
    },
    {}
  ), d = new URLSearchParams(i);
  return /* @__PURE__ */ c(f.Provider, { value: d, children: r });
}, k = () => {
  const t = s(f);
  return t || new URLSearchParams();
}, a = l(void 0), p = (t) => /* @__PURE__ */ c(a.Provider, { value: t, children: t.children });
p.displayName = "LinkProvider";
const y = () => {
  const t = s(a), e = k();
  if (t === void 0)
    throw new Error("useHref must be used within a HrefProvider");
  return P(
    w(t.siteSlug, e),
    [t.siteSlug, e]
  );
}, x = (t) => {
  const e = y(), { LinkComponent: r, ...n } = t;
  return /* @__PURE__ */ c(r, { ...n, href: e(n.href) });
}, b = (t, e, r = h) => {
  for (const n of r) {
    const i = t.searchParams.get(n);
    i !== null && !e.searchParams.has(n) && e.searchParams.set(n, i);
  }
  return e;
}, g = (t) => {
  const e = s(a);
  if (e === void 0)
    throw new Error("useLink must be used within a LinkProvider");
  const r = e.LinkComponent;
  return /* @__PURE__ */ c(x, { ...t, LinkComponent: r });
}, Q = (t) => {
  const e = s(a);
  if (e === void 0)
    throw new Error("useLink must be used within a LinkProvider");
  const r = e.LinkComponent;
  return /* @__PURE__ */ c(r, { ...t });
}, H = (t = { autoFormatHref: !0 }) => {
  if (s(a) === void 0)
    throw new Error("useLink must be used within a LinkProvider");
  return t.autoFormatHref ? g : Q;
}, S = () => {
  const t = s(a);
  if (t === void 0)
    throw new Error("useNavigate must be used within a LinkProvider");
  return t.navigate;
};
export {
  x as HrefFormattingLink,
  p as LinkProvider,
  W as WhitelistedQueryParamsProvider,
  L as constructInternalLink,
  h as defaultWhitelistedQueryParamKeys,
  w as getHrefFormatter,
  a as linkContext,
  b as preserveWhitelistedQueryParams,
  y as useHref,
  H as useLink,
  S as useNavigate,
  k as useWhitelistedQueryParams
};
